// @flow

import {useAnalytics, useLocation} from 'docs/data';

export const useLinkHandler = () => {
  const {getLinkInfo, pushLocation} = useLocation();
  const {trackLinkClick} = useAnalytics();

  return (event: SyntheticMouseEvent<>) => {
    // If the element that was clicked was a child of an anchor, find the nearest
    // anchor that was clicked so we can look at its href.
    const anchor: ?HTMLAnchorElement = (event.target: any).closest('a');

    // If we can't find an anchor, ignore the click.
    if (!anchor) {
      return;
    }

    trackLinkClick(anchor);

    // If the link manually sets the target, let the browser handle it.
    if (anchor.target) {
      return;
    }

    // If the user is holding a modifier key, or pressed a button other than the
    // left mouse button, let the browser handler it.
    if (event.metaKey || event.ctrlKey || event.button !== 0) {
      return;
    }

    const {href} = anchor;
    const link = getLinkInfo(href);

    // If the link is to another area on the docs site, let the shell handle it.
    if (link.type === 'docs') {
      pushLocation(href);
      event.preventDefault();
    }

    // If the link is not a doc page, open it in a new tab/window.
    // Some anchor tags are used as part of components like tabs, so we need to be
    // careful when overriding the default browser behavior.
    if (
      link.type === 'thirdparty' ||
      link.type === 'reference' ||
      link.type === 'dashboard' ||
      link.type === 'support'
    ) {
      window.open(href, '_blank');
      event.preventDefault();
    }

    // Let the default browser behavior handle all other events.
  };
};
